import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React from "react";
import { ROOT } from "./data-hooks";
import classes from "./floating-desktop-layout-scss";
const FloatingDesktopLayout = ({
  onCloseButtonClick,
  dataHook,
  header,
  content,
  footer,
  sidePanelProps
}) => {
  return /* @__PURE__ */ React.createElement(
    SidePanel,
    {
      skin: "floating",
      width: "360px",
      height: "fit-content",
      maxHeight: "420px",
      onCloseButtonClick,
      dataHook: classNames(ROOT, dataHook),
      ...sidePanelProps
    },
    header && /* @__PURE__ */ React.createElement(SidePanel.Header, { ...header }),
    /* @__PURE__ */ React.createElement(SidePanel.Content, { noPadding: true, ...content }),
    footer && /* @__PURE__ */ React.createElement(SidePanel.Footer, { className: classes.footer, ...footer })
  );
};
export {
  FloatingDesktopLayout
};
//# sourceMappingURL=floating-desktop-layout.js.map
